import React from 'react'
import { Link } from "react-router-dom";
import coreImg2 from "../assets/img/home3/block2.png";
import coreImg1 from "../assets/img/ProductsDetails/AboutCottonYarns2.jpg";
import PageBanner from "../Components/PageBanner";
import bannerBg from '../assets/img/Banners/Productpagebanner.jpg';
const CottonYarns = () => {
  return (
    <>
        <PageBanner title='Cotton Yarns ' bannerBg={bannerBg} currentPage=' Cotton Yarns  ' />
      <section className="content-block-wrapper section-padding bg-circle fix">
        <div className="container">
          <div className="row align-items-center ">
            <div className="col-xl-6 col-lg-6 pe-xl-4 col-12">
              <div className="content-block-img justify-content-center">
                <img src={coreImg1} alt="" />
              </div>
            </div>
            <div className="col-xl-6 ps-xl-5 col-lg-6 col-12 mt-5 mt-lg-0">
              <div className="section-title-3">
                {/* <h6>Core Features</h6> */}
                <h2>About Cotton Yarns
                </h2>
                {/* <h6>Oilseeds, Grains, and Pulses</h6> */}
                <p>
                The quality of cotton yarn is directly dependent on the cotton selected. Since cotton selection is a complex process—especially in India, where it is predominantly grown on rain-fed land—we implement a stringent quality control process at every stage, from cotton procurement to yarn production.  
                </p>
                <br></br>
                <p>
                For buyers seeking environmentally responsible options, we also offer Organic Cotton Yarns certified by the Global Organic Textile Standard (GOTS), ensuring sustainability and high-quality standards.     
                </p>
                <br></br>
              
               
               
              </div>
              {/* <div className="checked-features-list style-2">
                <ul>
                  <li>Brand Identity</li>
                  <li>Website Design &amp; Development</li>
                  <li>SEO &amp; Analytics</li>
                </ul>
              </div> */}
              
            </div>
          </div>
          <div className='row pt-50'>
            <div className='col-4'>
            <h6 className=' pb-4' style={{
                color:"#4E5AFF"
            }}>Ring Spun Combed Yarn</h6>
                <p>
                Ideal for knitting and weaving, our ring spun combed yarn is available in a wide range of counts. Medium-count yarns are the preferred choice for circular knitters and hosiery manufacturers, while our fine-count yarns—made from the world’s finest cotton—are used in high-end sheeting and shirting fabrics.   
                </p>
            </div>
           
            <div className='col-4 '>
            <h6 className=' pb-4' style={{
                color:"#4E5AFF"
            }}>Open End Yarn</h6>
                <p>
                "Open End" spinning eliminates the need for a rotating bobbin by twisting the yarn directly. Our extensive collection of open-end yarn includes cotton, acrylic, polyester, and polyester/cotton blends in a variety of colors. These yarns are widely used for sweaters, socks, woven garments, and blankets.   
                </p>
            </div>
            <div className='col-4 '>
            <h6 className=' pb-4' style={{
                color:"#4E5AFF"
            }}>Ring Spun Carded Yarn</h6>
                <p>
                Designed for both knitting and weaving, our ring spun carded yarn offers exceptional quality across a full range of coarse to fine counts.    
                </p>
            </div>
          </div>
         
        </div>
      </section> 
    </>
  )
}

export default CottonYarns
